/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoldersIcon24Solid = forwardRef('FoldersIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3a2 2 0 0 0-2 2v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4h-6.375a.75.75 0 0 1-.643-.364l-.4-.665A2 2 0 0 0 7.869 3H3Zm.75 6.75A.75.75 0 0 1 4.5 9h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M23.75 9.75a.75.75 0 0 0-1.5 0v7.75a4.75 4.75 0 0 1-4.75 4.75H5.75a.75.75 0 0 0 0 1.5H17.5a6.25 6.25 0 0 0 6.25-6.25V9.75Z" })));
});
